import React from 'react';

// Leisten über dem Header: Vorgangs-Zeitplan, Ablage-Fläche beim Datei-Ziehen
// und die globale Hinweisleiste (notification_config). #562: aus Header.js
// gelöst; rendert nur. Stile in kopfzeile.css.
const Leisten = ({ t, navigate, isProjectPlanningMode, projectPlanInfo, showGlobalDropOverlay, globalNotice }) => (
  <>
    {isProjectPlanningMode ? (
      <div className="kopf-zeitplanleiste">
        <div className="container kopf-zeitplanleiste-inhalt">
          <div className="kopf-zeitplanleiste-titel">{t('header.projectPlanningFor', 'Zeitplanung für Vorgang')} {projectPlanInfo.name || `#${projectPlanInfo.id}`}</div>
          <button
            onClick={() => {
              try {
                navigate(`/projects?projectId=${projectPlanInfo.id}`);
              } catch (_) {
                window.location.href = `/projects?projectId=${projectPlanInfo.id}`;
              }
            }}
            className="btn kopf-zeitplanleiste-knopf"
          >
            {t('header.backToProject', 'Zurück zum Vorgang')}
          </button>
        </div>
      </div>
    ) : null}
    {showGlobalDropOverlay && (
      <div className="kopf-ablage">
        <div className="kopf-ablage-karte">
          {t('header.dropHereNewTicket', 'Hier ablegen für neues Ticket')}
        </div>
      </div>
    )}
    {globalNotice.isActive && globalNotice.message ? (
      <div className="kopf-hinweisleiste">
        <div className="container kopf-hinweisleiste-inhalt">
          <span className="kopf-hinweisleiste-label">{t('header.notice', 'Hinweis:')}</span>
          <span className="kopf-einzeilig">{globalNotice.message}</span>
        </div>
      </div>
    ) : null}
  </>
);

export default Leisten;
